import React from "react"
import { getAllCountries } from "../../utils"
import SelectField from "../SelectField"

function CountryField(props) {
  function getAvailableCountries() {
    const countryList = getAllCountries().map(country => ({
      value: country.name.toLowerCase(),
      label: country.name
    }))
    if (props.availableCountries) {
      const availableCountries = props.availableCountries
      return countryList.filter(cObj =>
        availableCountries.find(aC => aC === cObj.value)
      )
    }
    return countryList
  }
  return (
    <span className="CountryField">
      <SelectField
        {...props}
        isSearchable={true}
        options={getAvailableCountries()}
        defaultValue={{ value: "none", label: "" }}
      />
    </span>
  )
}

export default CountryField
